import React, { Component } from 'react'
import { connect } from 'react-redux'

import appUrl, { openPost } from '@libs/appUrl'
import { noImg, isSecretClas } from '@libs/postTools'
import getSecretColor from '@libs/getSecretColor'

import Cover from './Cover'
import Like from '@components/Like'
import LazyLoadImg from '@components/LazyLoadImg'
import PosterName from '@components/PosterName'
import ClampLines from '@components/ClampLines'

import cx from 'classnames'
import styles from './index.scss'

import { dispatchCustomEvent, NavigationEvents, LikeUIEvents } from '@libs/customEvents'
import { LikeActionType } from '@libs/eventTracking/article'
import { trackWebHomePageSlideEnterArticleEvent } from '@libs/eventTracking/homePage/web-homepage.slide-show.enter-article'
import qs from 'qs'

import { postLike } from '@app-core/posts/actions'
import { trackWebCategoryArticleListLike } from '@libs/eventTracking/category'

export class ArticleCard extends Component {
  static defaultProps = {
    tagName: 'article',
    className: '',
    isSex: false,
    article: {
      clas: [],
      postID: '',
      type: '',
      title: '',
      text: '',
      img: [],
      reply: 0,
      userInfo: {
        img: '',
        name: '',
      },
      isLike: 0,
      like: 0,
      secretColor: getSecretColor(),
      web: {
        title: '',
        text: '',
      },
    },
    style: {},
    zoomIn: true,
    isLoaded: false,
    onLoaded: () => false,
    onClickPost: () => {},
  }
  constructor(props) {
    super(props)
    this.bgc = noImg
    this.noImg = {
      _id: '5d22043a51546306ed5a2613',
      uid: 'pop.popdaily_secret',
      type: 'post',
      t: 1562510394732,
      path: this.bgc,
      thumb: this.bgc,
      w: 900,
      h: 1170,
    }
    this.secretColor = { backgroundColor: `${props.article.secretColor}` }
    this.state = {
      isAD: props.article.type === 'ad',
      isRandom: props.className.includes('random-article') || false,
      isLike: !!props.article.isLike || false,
      likeNum: props.article.like || 0,
    }
  }

  handleRef = (node) => (this.articleCard = this.articleCard || node)

  shouldComponentUpdate(nextProps, nextState) {
    //props
    if (this.props.zoomIn !== nextProps.zoomIn) {
      return true
    }
    //state
    if (this.state.isLoaded !== nextState.isLoaded || this.state.isLike !== nextState.isLike) {
      return true
    }
    // default:false
    return false
  }

  componentDidMount() {
    this._onCoverImgLoaded() // 無論圖片是否已經 loaded 完畢都執行loaded佔位
  }

  _onLikeClick = () => {
    const { article: post, instagram, postSection, dispatch } = this.props
    if (instagram) return
    const isLike = !this.state.isLike
    if (postSection === 'sameAuthor') {
      dispatchCustomEvent(LikeUIEvents.READ_MORE_SANE_AUTHOR_CLICK_LIKE, {
        actionType: isLike ? LikeActionType.LIKE : LikeActionType.UNLIKE,
      })
    }
    if (postSection === 'sameTypeArticle') {
      dispatchCustomEvent(LikeUIEvents.READ_MORE_SANE_TYPE_CLICK_LIKE, {
        actionType: isLike ? LikeActionType.LIKE : LikeActionType.UNLIKE,
      })
    }
    const likeNum = this.state.likeNum + (!this.state.isLike ? 1 : -1)
    this.setState((state) => ({ ...state, isLike, likeNum }))
    trackWebCategoryArticleListLike({
      postID: post.postID,
      actionType: isLike ? 'like' : 'unlike',
      category: post.clas[0],
    })
    dispatch(postLike({ postID: post.postID, isLike: isLike ? 1 : 0, data: post }))
  }

  _onClickPost =
    (type = '', postID = '', shortcode = '') =>
    () => {
      const { instagram, postSection, onClickPost } = this.props
      if (this.props.className.includes('Carousel')) {
        const postUrl = `${appUrl.myhost}/${postID.replace(/\./g, '/')}`
        const trackQueryString = qs.stringify({
          ...qs.parse(postUrl.split('?')[1]),
          fromPage: {
            pageName: 'web-homepage',
            pageComponent: 'slide-show',
          },
        })
        trackWebHomePageSlideEnterArticleEvent({
          currentPage: {
            pageName: 'web-homepage',
          },
          toPage: {
            pageUrl: postUrl,
          },
          actionTarget: postID,
        })
        openPost(`${postUrl}?${trackQueryString}`)
        onClickPost()
        return
      }
      if (instagram) {
        openPost(`https://www.instagram.com/p/${shortcode}/`)
      }
      if (type && postID && type !== 'ad') {
        if (postSection === 'sameAuthor') {
          dispatchCustomEvent(NavigationEvents.ENTER_READ_MORE_SAME_AUTHOR, {
            toPath: `/${postID.replace(/\./g, '/')}`,
          })
        }
        if (postSection === 'sameTypeArticle') {
          dispatchCustomEvent(NavigationEvents.ENTER_READ_MORE_SAME_TYPE, {
            toPath: `/${postID.replace(/\./g, '/')}`,
          })
        }
        openPost(`/${postID.replace(/\./g, '/')}`)
      }
      onClickPost({ type, postID })
    }

  _getCoverImgSrc = (coverImg) => {
    const { className } = this.props
    const { path = '', thumb = '' } = coverImg
    return className.includes('PcCarousel') ? path : thumb
  }

  _onCoverImgLoaded = () => {
    if (!this.state.isLoaded) {
      this.setState((state) => ({ ...state, isLoaded: true }))
      if (this.props.onLoaded) this.props.onLoaded()
    }
  }

  isSecret() {
    const { clas = [], img = [] } = this.props.article
    const coverImg = img.length > 0 ? img[0] : this.noImg
    const coverImgSrc = this._getCoverImgSrc(coverImg)
    return isSecretClas(clas) && coverImgSrc === ''
  }

  renderCover() {
    const { isAD } = this.state
    const { className, article } = this.props
    const { img, img3_4, title, text, editorType } = article
    return (
      <Cover
        className={className}
        isAD={isAD}
        isSecret={this.isSecret()}
        secretColor={article.secretColor}
        img={img}
        img3_4={img3_4}
        title={title}
        text={text}
        handleLoaded={this._onCoverImgLoaded}
        editorType={editorType}
      />
    )
  }

  transformToNode = (node) => (node.type === 'text' ? node.data || '' : null)

  renderContent() {
    const { isRandom } = this.state
    const { article } = this.props
    const { type = '', web = {} } = article
    const isWeb = type === 'web' || type === 'pugc'
    const title = isWeb ? web.title : article.title || ''
    const text = isWeb ? web.text : article.text || ''
    const lines = isRandom ? 4 : 2
    return !this.isSecret() ? (
      <ClampLines transform={this.transformToNode} lines={lines} title={title} text={text} />
    ) : null
  }

  render() {
    const { isAD, isRandom, isLike = false, likeNum = 0, isLoaded } = this.state
    const { tagName: Tag, className, article, zoomIn, style, index, isSex } = this.props
    const {
      postID,
      title = '',
      text = '',
      userInfo: { img, name },
      type = '',
      shortcode = '',
      reply,
    } = article
    const classNames = cx('articleCard articleCard articleCard', className.split(' '), {
      isAD,
      isLoaded,
      zoomIn,
    })
    const data = {
      id: postID,
      'data-postid': postID,
      'data-type': type,
      'data-url': `${appUrl.myhost}/${postID.replace(/\./g, '/')}`,
    }

    if (!title && !text) return null
    return (
      <Tag
        key={postID}
        {...data}
        ref={this.handleRef}
        className={classNames}
        onClick={this._onClickPost(type, postID, shortcode)}
        style={style}
        data-index={index}
      >
        <style jsx>{styles}</style>
        {!isRandom && this.renderCover()}
        <div className="articleCard-content">
          {!isSex && this.renderContent()}
          {isRandom && this.renderCover()}
          <div className="articleCard-child">
            {isSex ? (
              <div className="articleCard-reply">{reply} 留言</div>
            ) : (
              <div className="articleCard-author">
                <LazyLoadImg
                  className="articleCard-author-img"
                  src={img}
                  alt={name}
                  style={this.isSecret() ? this.secretColor : {}}
                />
                <PosterName className="articleCard-author-name" text={name} />
              </div>
            )}
            <Like id={postID} likeNum={likeNum} isLike={isLike} onClickLike={this._onLikeClick} />
          </div>
        </div>
      </Tag>
    )
  }
}

export default connect(null)(ArticleCard)
